import { DEFAULT_ICONS_V2, ELEMENT_TYPE } from "@/constants";
import { Audio, LinkU, MapIcon } from "@/icons";

import { ContentElementService, ElementService } from "../services";

export async function deleteElement(propertyId, experienceId, elementId) {
  await ElementService.deleteElement(propertyId, experienceId, elementId);
}

export async function deleteContentElement(propertyId, mediaItemId, elementId) {
  await ContentElementService.deleteContentElement(propertyId, mediaItemId, elementId);
}

export const ELEMENT_ICONS_VALUE = {
  [ELEMENT_TYPE.MAP]: MapIcon,
  [ELEMENT_TYPE.LINK]: LinkU,
  [ELEMENT_TYPE.CONTENT]: LinkU,
  [ELEMENT_TYPE.VOICE_MEMO]: Audio,
};

export const ELEMENT_DEFAULT_ICONS_VALUE = Object.values(DEFAULT_ICONS_V2).map(
  (link) => `/${link.split("/").splice(-3).join("/")}`,
);
